export const SET_SHOW_PREFERENCES_MODAL = 'SET_SHOW_PREFERENCES_MODAL';
export const SET_HIDE_PREFERENCES_MODAL = 'SET_HIDE_PREFERENCES_MODAL';

export const ActionShowModalPreferences = () => {
    return {
        type: "SET_SHOW_PREFERENCES_MODAL",
        payload: true,
    };
};

export const ActionHideModalPreferences = () => {
    return {
        type: "SET_HIDE_PREFERENCES_MODAL",
        payload: false,
    };
    
}

